import { createContext, useState } from 'react';
import api from 'services/api';

export const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [postLoading, setPostLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      const { data: dt } = await api.post('/WMS/Armazenagem/Etiqueta', data, {
        responseType: 'blob',
      });
      const file = new Blob([dt], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProdutoIndicadores = async ({ id, item_id = '', cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(
        `/Graficos/CadastrosProdutoIndicadores/${id}/${item_id}`
      );
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosContext.Provider
      value={{ getLoading, postLoading, postEtiquetas, getProdutoIndicadores }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};
